import { render } from "./BaseRecordCard.vue?vue&type=template&id=6f14d9de&scoped=true"
import script from "./BaseRecordCard.vue?vue&type=script&lang=js"
export * from "./BaseRecordCard.vue?vue&type=script&lang=js"

import "./BaseRecordCard.vue?vue&type=style&index=0&id=6f14d9de&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_plan_1778832654194047890/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f14d9de"]])

export default __exports__